import React from "react";
import { Flex, Text } from "@aws-amplify/ui-react";
import { UserRole, getUserRoleLabel } from "../../data/interfaces";

interface ProfileHeaderProps {
  name?: string;
  email?: string;
  role?: UserRole;
}

const ProfileHeader = (props: ProfileHeaderProps) => {
  return (
    <>
      <Flex
        direction={{ base: "column", large: "row" }}
        alignItems="flex-start"
      >
        <div className="profile-header-text">
          <Text variation="primary" fontWeight={600} fontSize="18px">
            {props.name ?? "-"}
          </Text>
          <Text variation="secondary">
            {getUserRoleLabel(props.role) ?? '?'}
          </Text>
          <Text variation="tertiary">
            <i>{props.email ?? "-"}</i>
          </Text>
        </div>
      </Flex>
    </>
  );
};

export default ProfileHeader;
